import {
  normalizeHdvtLine,
  type HopDongCreateRequest,
  type HopDongFormFields,
  type HopDongHdvtInput,
  type HopDongHdvtLineDraft,
  type HopDongUpdateRequest,
} from '@/types/hop-dong';

interface BuildPayloadOptions {
  hopDong: HopDongFormFields;
  lines: HopDongHdvtLineDraft[];
}

export function filterHdvtLines(
  lines: HopDongHdvtLineDraft[]
): HopDongHdvtInput[] {
  return lines
    .map(normalizeHdvtLine)
    .filter((item): item is HopDongHdvtInput => item !== null);
}

export function buildHopDongCreatePayload(
  options: BuildPayloadOptions
): HopDongCreateRequest {
  return {
    hopDong: options.hopDong,
    hdvt: filterHdvtLines(options.lines),
  };
}

export function buildHopDongUpdatePayload(
  options: BuildPayloadOptions
): HopDongUpdateRequest {
  return {
    hopDong: options.hopDong,
    hdvt: filterHdvtLines(options.lines),
  };
}

export type { HopDongHdvtLineDraft };
